import { render, staticRenderFns } from "./ThePersonalSkeletonBox.vue?vue&type=template&id=977d5f2a&"
import script from "./ThePersonalSkeletonBox.vue?vue&type=script&lang=js&"
export * from "./ThePersonalSkeletonBox.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalSkeletonBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports